export default [
  {
    id: '140',
    name: '腕時計/Laurentモデル',
    image: '/assets/images/goods-140_l.jpg',
    thumb: '/assets/images/goods-140_s.jpg',
    url: 'https://www.cocollabo.net/shop/pages/solwa-grpr.aspx',
    spec: {
      '価格': '15,400円',
      '仕様': 'ご予約特典：描きおろしアクリルスタンド（ローラン）<br>■素材・ケース：スンレススチール・メッキ/　バンド：スンレススチール・ムーブメント：日本製（MIYOTA2035）　■サイズ・ケースサイズ：経30mm・ケースの厚さ：9mm（裏蓋含む）バンドサイズ：185ｍｍ・バンド幅：13mm　■防水：3気圧防水（生活防水）　■生産国：中国（ムーブメント：日本製MIYOTA2035）',
      '発売元': '株式会社キャラバン'
    }
  },
  {
    id: '139',
    name: 'ラウンド本革長財布/GREAT PRETENDERモデル',
    image: '/assets/images/goods-139_l.jpg',
    thumb: '/assets/images/goods-139_s.jpg',
    url: 'https://www.cocollabo.net/shop/pages/solwa-grpr.aspx',
    spec: {
      '価格': '17,600円',
      '仕様': 'ご予約特典：描きおろしアクリルスタンド（エダマメ）<br>■材質：牛革（本体、チャーム）、ポリエステル（内生地）、合金（金具部分）　■生産国：タイ　■サイズ：W190×H100×D25mm',
      '発売元': '株式会社キャラバン'
    }
  },
  {
    id: '138',
    name: 'LINE着せかえ　シンシアver',
    image: '/assets/images/goods-138_l.jpg',
    thumb: '/assets/images/goods-138_s.jpg',
    url: 'https://line.me/S/shop/theme/detail?id=439572c6-f0c1-4288-9f54-1d4b3e06764d',
    spec: {
      '価格': '370円または、150コイン',
      '仕様': 'LINEアプリ利用可能端末(iOS/Android)',
      '発売元': '株式会社インクルーズ'
    }
  },
  {
    id: '137',
    name: 'LINE着せかえ　アビーver',
    image: '/assets/images/goods-137_l.jpg',
    thumb: '/assets/images/goods-137_s.jpg',
    url: 'https://line.me/S/shop/theme/detail?id=acc1c973-1675-4bc6-9c72-c5d0428e4a6d',
    spec: {
      '価格': '370円または、150コイン',
      '仕様': 'LINEアプリ利用可能端末(iOS/Android)',
      '発売元': '株式会社インクルーズ'
    }
  },
  {
    id: '136',
    name: 'LINE着せかえ　ローランver',
    image: '/assets/images/goods-136_l.jpg',
    thumb: '/assets/images/goods-136_s.jpg',
    url: 'https://store.line.me/themeshop/product/63a39cbb-4927-4605-98f6-a9dcc8f62ee4',
    spec: {
      '価格': '370円または、150コイン',
      '仕様': 'LINEアプリ利用可能端末(iOS/Android)',
      '発売元': '株式会社インクルーズ'
    }
  },
  {
    id: '135',
    name: 'LINE着せかえ　枝村真人ver',
    image: '/assets/images/goods-135_l.jpg',
    thumb: '/assets/images/goods-135_s.jpg',
    url: 'https://line.me/S/shop/theme/detail?id=a4f08ef3-148c-44c1-afbc-1257f14f78a1',
    spec: {
      '価格': '370円または、150コイン',
      '仕様': 'LINEアプリ利用可能端末(iOS/Android)',
      '発売元': '株式会社インクルーズ'
    }
  },
  {
    id: '134',
    name: 'アニピク（デジタルブロマイド/全50種）第二弾',
    image: '/assets/images/goods-134_l.jpg',
    thumb: '/assets/images/goods-134_s.jpg',
    url: 'https://anipic.io/ja/greatpretender-case4',
    spec: {
      '価格': '各360円（税込）または、120コイン',
      '仕様': '「AniPic!」はデジタルブロマイドのコレクションサービスです。表面では『GREAT PRETENDER』の数々の場面写真を観ることができ、裏面では制作陣からのコメントなどを読むことができます。第一弾販売の大好評を受け、第二弾の発売開始！詳細はURLをチェック！',
      '発売元': '株式会社YUIMEX'
    }
  },
  {
    id: '130',
    name: 'LINE着せかえ',
    image: '/assets/images/goods-130_l.jpg',
    thumb: '/assets/images/goods-130_s.jpg',
    url: 'https://line.me/S/shop/theme/detail?id=3e983060-f961-416c-9182-48c5c0da67da',
    spec: {
      '価格': '370円（税込）または、150コイン',
      '仕様': 'LINEアプリ利用可能端末(iOS/Android)',
      '発売元': '株式会社インクルーズ'
    }
  },
  {
    id: '133',
    name: 'ボックスロゴ パーカー',
    image: '/assets/images/goods-133_l.jpg',
    thumb: '/assets/images/goods-133_s.jpg',
    url: 'https://amnibus.com/products/title/559',
    spec: {
      '価格': '6,578円（税込）',
      '仕様': '綿100％ メンズ：XS～XXL レディース：M～XXXL',
      '発売元': '株式会社arma bianca'
    }
  },
  {
    id: '132',
    name: 'ボックスロゴ Tシャツ',
    image: '/assets/images/goods-132_l.jpg',
    thumb: '/assets/images/goods-132_s.jpg',
    url: 'https://amnibus.com/products/title/559',
    spec: {
      '価格': '4,180円（税込）',
      '仕様': '綿100% メンズ：S～XXL レディース：M～XXL',
      '発売元': '株式会社arma bianca'
    }
  },
  {
    id: '131',
    name: 'モノクロビジュアル マグカップ',
    image: '/assets/images/goods-131_l.jpg',
    thumb: '/assets/images/goods-131_s.jpg',
    url: 'https://amnibus.com/products/title/559',
    spec: {
      '価格': '1,650円（税込）',
      '仕様': '陶器 （約）直径82mm×高さ95mm',
      '発売元': '株式会社arma bianca'
    }
  },
  {
    id: '129',
    name: 'ルームキーホルダー（全4種）',
    image: '/assets/images/goods-129_l.jpg',
    thumb: '/assets/images/goods-129_s.jpg',
    url: 'https://www.hmv.co.jp/news/article/2012111008/',
    spec: {
      '価格': '各660円（税込）',
      '仕様': 'アクリル 約H95×W20mm',
      '発売元': 'ダブルカルチャーパートナーズ'
    }
  },
  {
    id: '128',
    name: 'フィルム風アクリルキーホルダー（全5種）',
    image: '/assets/images/goods-128_l.jpg',
    thumb: '/assets/images/goods-128_s.jpg',
    url: 'https://www.hmv.co.jp/news/article/2012111008/',
    spec: {
      '価格': '各803円（税込）',
      '仕様': 'アクリル 約H80×W50mm',
      '発売元': 'ダブルカルチャーパートナーズ'
    }
  },
  {
    id: '127',
    name: 'クリアファイルセット',
    image: '/assets/images/goods-127_l.jpg',
    thumb: '/assets/images/goods-127_s.jpg',
    url: 'https://www.hmv.co.jp/news/article/2012111008/',
    spec: {
      '価格': '880円（税込）',
      '仕様': 'PP A4対応',
      '発売元': 'ダブルカルチャーパートナーズ'
    }
  },
  {
    id: '126',
    name: 'クリアポーチ',
    image: '/assets/images/goods-126_l.jpg',
    thumb: '/assets/images/goods-126_s.jpg',
    url: 'https://www.hmv.co.jp/news/article/2012111008/',
    spec: {
      '価格': '1,760円（税込）',
      '仕様': 'PVC 約H140×W180mm',
      '発売元': 'ダブルカルチャーパートナーズ'
    }
  },
  {
    id: '125',
    name: 'トートバッグ',
    image: '/assets/images/goods-125_l.jpg',
    thumb: '/assets/images/goods-125_s.jpg',
    url: 'https://www.hmv.co.jp/news/article/2012111008/',
    spec: {
      '価格': '2,420円（税込）',
      '仕様': 'コットン　約H370×W360×D100mm',
      '発売元': 'ダブルカルチャーパートナーズ'
    }
  },
  {
    id: '124',
    name: 'B2タペストリー',
    image: '/assets/images/goods-124_l.jpg',
    thumb: '/assets/images/goods-124_s.jpg',
    url: 'https://www.hmv.co.jp/news/article/2012111008/',
    spec: {
      '価格': '3,300円（税込）',
      '仕様': 'ポリエステル　B2サイズ',
      '発売元': 'ダブルカルチャーパートナーズ'
    }
  },
  {
    id: '123',
    name: 'IDカードケース',
    image: '/assets/images/goods-123_l.jpg',
    thumb: '/assets/images/goods-123_s.jpg',
    url: 'https://www.hmv.co.jp/news/article/2012111008/',
    spec: {
      '価格': '1,980円（税込）',
      '仕様': 'PU　H74×W103mm /ストラップ長さ830x幅8mm',
      '発売元': 'ダブルカルチャーパートナーズ'
    }
  },
  {
    id: '122',
    name: '缶バッジ（全4種）',
    image: '/assets/images/goods-122_l.jpg',
    thumb: '/assets/images/goods-122_s.jpg',
    url: 'https://www.hmv.co.jp/news/article/2012111008/',
    spec: {
      '価格': '各550円（税込）',
      '仕様': 'ブリキ Φ54mm',
      '発売元': 'ダブルカルチャーパートナーズ'
    }
  },
  {
    id: '121',
    name: 'アクリルスタンド（全4種）',
    image: '/assets/images/goods-121_l.jpg',
    thumb: '/assets/images/goods-121_s.jpg',
    url: 'https://www.hmv.co.jp/news/article/2012111008/',
    spec: {
      '価格': '各1,650円（税込）',
      '仕様': 'アクリル　約H130mm',
      '発売元': 'ダブルカルチャーパートナーズ'
    }
  },
  {
    id: '120',
    name: 'コラボレーションイヤフォン',
    image: '/assets/images/goods-120-2_l.jpg',
    thumb: '/assets/images/goods-120-2_s.jpg',
    url: 'https://zeeny.com/products/zeeny-lights-hd-x-great-pretender',
    spec: {
      '価格': '16,280円（税込）',
      '仕様': '樹脂（デバイス）D38mm×W72mm×H29mm<br>紙（パッケージ）D105mm×W100mm×H45mm',
      '発売元': '株式会社ネイン',
      '備考': '監修中のためデザインが変更になる可能性がございます'
    }
  },
  {
    id: '119',
    name: 'GREAT PRETENDER × TOWER RECORDSステムレスワイングラス',
    image: '/assets/images/goods-119_l.jpg',
    thumb: '/assets/images/goods-119_s.jpg',
    url: 'https://tower.jp/item/5138798',
    spec: {
      '価格': '1,540円（税込）',
      '仕様': 'ガラス　約φ50㎜×H87㎜',
      '発売元': 'タワーレコード㈱'
    }
  },
  {
    id: '118',
    name: 'GREAT PRETENDER × TOWER RECORDS風呂敷C',
    image: '/assets/images/goods-118_l.jpg',
    thumb: '/assets/images/goods-118_s.jpg',
    url: 'https://tower.jp/item/5138797',
    spec: {
      '価格': '1,650円（税込）',
      '仕様': 'ポリエステル　約W500×H500㎜',
      '発売元': 'タワーレコード㈱'
    }
  },
  {
    id: '117',
    name: 'GREAT PRETENDER × TOWER RECORDS風呂敷B',
    image: '/assets/images/goods-117_l.jpg',
    thumb: '/assets/images/goods-117_s.jpg',
    url: 'https://tower.jp/item/5138796',
    spec: {
      '価格': '1,650円（税込）',
      '仕様': 'ポリエステル　約W500×H500㎜',
      '発売元': 'タワーレコード㈱'
    }
  },
  {
    id: '116',
    name: 'GREAT PRETENDER × TOWER RECORDS風呂敷A',
    image: '/assets/images/goods-116_l.jpg',
    thumb: '/assets/images/goods-116_s.jpg',
    url: 'https://tower.jp/item/5138795',
    spec: {
      '価格': '1,650円（税込）',
      '仕様': 'ポリエステル　約W500×H500㎜',
      '発売元': 'タワーレコード㈱'
    }
  },
  {
    id: '115',
    name: 'GREAT PRETENDER × TOWER RECORDSステッカーセット',
    image: '/assets/images/goods-115_l.jpg',
    thumb: '/assets/images/goods-115_s.jpg',
    url: 'https://tower.jp/item/5138794',
    spec: {
      '価格': '440円（税込）',
      '仕様': '紙　約W100×H100㎜',
      '発売元': 'タワーレコード㈱'
    }
  },
  {
    id: '114',
    name: 'GREAT PRETENDER × TOWER RECORDSポケットエコバック',
    image: '/assets/images/goods-114_l.jpg',
    thumb: '/assets/images/goods-114_s.jpg',
    url: 'https://tower.jp/item/5138793',
    spec: {
      '価格': '1,650円（税込）',
      '仕様': 'ポリエステル　本体：約W360×H365×D120㎜　ポーチ：約W110×H155㎜',
      '発売元': 'タワーレコード㈱'
    }
  },
  {
    id: '113',
    name: 'GREAT PRETENDER × TOWER RECORDSマジックマグカップ',
    image: '/assets/images/goods-113_l.jpg',
    thumb: '/assets/images/goods-113_s.jpg',
    url: 'https://tower.jp/item/5138792',
    spec: {
      '価格': '2,200円（税込）',
      '仕様': '陶器　約φ80×H91㎜',
      '発売元': 'タワーレコード㈱'
    }
  },
  {
    id: '112',
    name: 'GREAT PRETENDER × TOWER RECORDSアクリルパネル',
    image: '/assets/images/goods-112_l.jpg',
    thumb: '/assets/images/goods-112_s.jpg',
    url: 'https://tower.jp/item/5138791',
    spec: {
      '価格': '2,750円（税込）',
      '仕様': 'アクリル　　約W150×H150㎜',
      '発売元': 'タワーレコード㈱'
    }
  },
  {
    id: '111',
    name: 'GREAT PRETENDER × TOWER RECORDS缶バッジ ローラン',
    image: '/assets/images/goods-111_l.jpg',
    thumb: '/assets/images/goods-111_s.jpg',
    url: 'https://tower.jp/item/5138790',
    spec: {
      '価格': '605円（税込）',
      '仕様': '紙、ブリキ　約φ75㎜',
      '発売元': 'タワーレコード㈱'
    }
  },
  {
    id: '110',
    name: 'GREAT PRETENDER × TOWER RECORDS缶バッジ エダマメ',
    image: '/assets/images/goods-110_l.jpg',
    thumb: '/assets/images/goods-110_s.jpg',
    url: 'https://tower.jp/item/5138789',
    spec: {
      '価格': '605円（税込）',
      '仕様': '紙、ブリキ　約φ75㎜',
      '発売元': 'タワーレコード㈱'
    }
  },
  {
    id: '109',
    name: 'GREAT PRETENDER × TOWER RECORDSアクリルスタンド ローラン',
    image: '/assets/images/goods-109_l.jpg',
    thumb: '/assets/images/goods-109_s.jpg',
    url: 'https://tower.jp/item/5138788',
    spec: {
      '価格': '1,320円（税込）',
      '仕様': 'アクリル　本体：約W60×H130㎜　台座：約φ50㎜',
      '発売元': 'タワーレコード㈱'
    }
  },
  {
    id: '108',
    name: 'GREAT PRETENDER × TOWER RECORDSアクリルスタンド エダマメ',
    image: '/assets/images/goods-108_l.jpg',
    thumb: '/assets/images/goods-108_s.jpg',
    url: 'https://tower.jp/item/5138787',
    spec: {
      '価格': '1,320円（税込）',
      '仕様': 'アクリル　本体：約W60×H130㎜　台座：約φ50㎜',
      '発売元': 'タワーレコード㈱'
    }
  },
  {
    id: '107',
    name: 'マグカップ',
    image: '/assets/images/goods-107_l.jpg',
    thumb: '/assets/images/goods-107_s.jpg',
    url: 'https://www.the-chara.com/view/search?search_category=ct2106',
    spec: {
      '価格': '各1,650円(税込)',
      '仕様': '素材：陶器　サイズ：高さ約9.5cm×直径約7.5cm',
      '発売元': '株式会社コンテンツシード'
    }
  },
  {
    id: '106',
    name: '合皮パスケース',
    image: '/assets/images/goods-106_l.jpg',
    thumb: '/assets/images/goods-106_s.jpg',
    url: 'https://www.the-chara.com/view/search?search_category=ct2106',
    spec: {
      '価格': '1,320円(税込)',
      '仕様': '素材：合皮　サイズ：100×78mm',
      '発売元': '株式会社コンテンツシード'
    }
  },
  {
    id: '105',
    name: 'アクリルスマホスタンド',
    image: '/assets/images/goods-105_l.jpg',
    thumb: '/assets/images/goods-105_s.jpg',
    url: 'https://www.the-chara.com/view/search?search_category=ct2106',
    spec: {
      '価格': '各1,650円(税込)',
      '仕様': '素材：アクリル(クリア)　サイズ：W110×H155mm',
      '発売元': '株式会社コンテンツシード'
    }
  },
  {
    id: '104',
    name: 'リングアクリルキーホルダー',
    image: '/assets/images/goods-104_l.jpg',
    thumb: '/assets/images/goods-104_s.jpg',
    url: 'https://www.the-chara.com/view/search?search_category=ct2106',
    spec: {
      '価格': '各880円(税込)',
      '仕様': '素材：アクリル(クリア)　サイズ：約37mm×71mm',
      '発売元': '株式会社コンテンツシード'
    }
  },
  {
    id: '103',
    name: 'アクリル万年カレンダー',
    image: '/assets/images/goods-103_l.jpg',
    thumb: '/assets/images/goods-103_s.jpg',
    url: 'https://www.the-chara.com/view/search?search_category=ct2106',
    spec: {
      '価格': '2,200円(税込)',
      '仕様': '素材：アクリル(クリア)　サイズ：W130mm×H187mm',
      '発売元': '株式会社コンテンツシード'
    }
  },
  {
    id: '102',
    name: 'つながるアクリルキーホルダー(ブラインド)',
    image: '/assets/images/goods-102_l.jpg',
    thumb: '/assets/images/goods-102_s.jpg',
    url: 'https://www.the-chara.com/view/search?search_category=ct2106',
    spec: {
      '価格': '550円(税込)',
      '仕様': '素材：アクリル(クリア)　サイズ：全高約6cm',
      '発売元': '株式会社コンテンツシード'
    }
  },
  {
    id: '101',
    name: 'カンバッジ(ブラインド)',
    image: '/assets/images/goods-101_l.jpg',
    thumb: '/assets/images/goods-101_s.jpg',
    url: 'https://www.the-chara.com/view/search?search_category=ct2106',
    spec: {
      '価格': '550円(税込)',
      '仕様': '素材：ブリキ　サイズ：直径56mm',
      '発売元': '株式会社コンテンツシード'
    }
  },
  {
    id: '100',
    name: 'モノクロビジュアル モバイルバッテリー',
    image: '/assets/images/goods-100_l.jpg',
    thumb: '/assets/images/goods-100_s.jpg',
    url: 'https://amnibus.com/products/title/559',
    spec: {
      '価格': '4,950円（税込）',
      '仕様': 'ABS樹脂 TPU W+B54120×W68×T9mm',
      '発売元': '株式会社arma bianca'
    }
  },
  {
    id: '099',
    name: 'モノクロビジュアル 1ポケットパスケース',
    image: '/assets/images/goods-099_l.jpg',
    thumb: '/assets/images/goods-099_s.jpg',
    url: 'https://amnibus.com/products/title/559',
    spec: {
      '価格': '1,980円（税込）',
      '仕様': '合成皮革　W 71×H 103mm',
      '発売元': '株式会社arma bianca'
    }
  },
  {
    id: '098',
    name: 'トレーディング缶バッジ',
    image: '/assets/images/goods-098_l.jpg',
    thumb: '/assets/images/goods-098_s.jpg',
    url: 'https://amnibus.com/products/title/559',
    spec: {
      '価格': '単品：440円（税込）、BOX：3,520円（税込）',
      '仕様': '紙、ブリキ （約）直径56mm',
      '発売元': '株式会社arma bianca'
    }
  },
  {
    id: '097',
    name: 'トレーディングミニアートフレーム',
    image: '/assets/images/goods-097_l.jpg',
    thumb: '/assets/images/goods-097_s.jpg',
    url: 'https://amnibus.com/products/title/559',
    spec: {
      '価格': '単品：715円（税込）、BOX：5,720円（税込）',
      '仕様': 'アクリル、ABS樹脂 W 55×H 40mm',
      '発売元': '株式会社arma bianca'
    }
  },
  {
    id: '096',
    name: 'フレームアート',
    image: '/assets/images/goods-096_l.jpg',
    thumb: '/assets/images/goods-096_s.jpg',
    url: 'https://market.funs-project.com/07OKz3EjVEAqDnYL/reserve-products/LzGd0XYORxKJ18BE?utm_source=gp_official&utm_medium=display&utm=campaign=gp_official',
    spec: {
      '価格': '3,850円（税込）',
      '仕様': '箔押しデザイン付きのフレームに入ったアートポスターです。サイズはＡ４サイズ。ラインナップは全7種。フレームは白・黒の2色から選べます。',
      '発売元': '大日本印刷株式会社'
    }
  },
  {
    id: '095',
    name: 'カスタマイズＴシャツ Black',
    image: '/assets/images/goods-095_l.jpg',
    thumb: '/assets/images/goods-095_s.jpg',
    url: 'https://market.funs-project.com/07OKz3EjVEAqDnYL/reserve-products/862jm0qB4ZYXkRDr?utm_source=gp_official&utm_medium=display&utm=campaign=gp_official',
    spec: {
      '価格': '4,378円（税込）',
      '仕様': '場面写43種×背景4色×ロゴ2種を組み合わせてデザインをカスタマイズできるＴシャツです。<br>サイズ：S/M/L/LL<br>素材：綿100%',
      '発売元': '大日本印刷株式会社'
    }
  },
  {
    id: '094',
    name: 'カスタマイズＴシャツ White',
    image: '/assets/images/goods-094_l.jpg',
    thumb: '/assets/images/goods-094_s.jpg',
    url: 'https://market.funs-project.com/07OKz3EjVEAqDnYL/reserve-products/jJan9QYEPPK6Xdw1?utm_source=gp_official&utm_medium=display&utm=campaign=gp_official',
    spec: {
      '価格': '3,278円（税込）',
      '仕様': '場面写43種×背景4色×ロゴ2種を組み合わせてデザインをカスタマイズできるＴシャツです。<br>サイズ：S/M/L/LL<br>素材：綿100%',
      '発売元': '大日本印刷株式会社'
    }
  },
  {
    id: '093',
    name: 'アニピク（デジタルブロマイド/全51種）',
    image: '/assets/images/goods-093_l.jpg',
    thumb: '/assets/images/goods-093_s.jpg',
    url: 'https://anipic.io/ja/greatpretender-case1-3',
    spec: {
      '価格': '各360円（税込）または、120コイン',
      '仕様': '「AniPic!」はデジタルブロマイドのコレクションサービスです。表面では『GREAT PRETENDER』の数々の場面写真を観ることができ、裏面では制作陣からのコメントなどを読むことができます。',
      '発売元': '株式会社YUIMEX'
    }
  },
  {
    id: '092',
    name: 'Tシャツ',
    image: '/assets/images/goods-092_l.jpg',
    thumb: '/assets/images/goods-092_s.jpg',
    url: 'https://core-choco.shop-pro.jp/?pid=155096835',
    spec: {
      '価格': '¥4,400（税込）',
      '仕様': 'コンフィデンスバニラホワイト（全１種）　綿 100% サイズ展開:160/S/M/L/XL/XXL',
      '発売元': '有限会社ハードコアチョコレート'
    }
  },
  {
    id: '091',
    name: 'LINE着せかえ',
    image: '/assets/images/goods-091_l.jpg',
    thumb: '/assets/images/goods-091_s.jpg',
    url: 'https://line.me/S/shop/theme/detail?id=9d79de98-e4ad-4f8c-8dc9-dc5f1c132f1d',
    spec: {
      '価格': '370円（税込）または、150コイン',
      '仕様': 'LINEアプリ利用可能端末(iOS/Android)',
      '発売元': '株式会社インクルーズ'
    }
  },
  {
    id: '090',
    name: 'マスクケース',
    image: '/assets/images/goods-090_l.jpg',
    thumb: '/assets/images/goods-090_s.jpg',
    url: 'https://culcolle.online/collections/iitem-1/?ohp=grp',
    spec: {
      '価格': '各 ¥1,980円（税込）',
      '仕様': '素材：合皮<br>サイズ：110×220(mm)',
      '発売元': '株式会社ひかりてらす'
    }
  },
  {
    id: '089',
    name: 'ファッションマスク',
    image: '/assets/images/goods-089_l.jpg',
    thumb: '/assets/images/goods-089_s.jpg',
    url: 'https://culcolle.online/collections/iitem-1/?ohp=grp',
    spec: {
      '価格': '各 ¥1,650円（税込）',
      '仕様': 'サイズ：約H120×W170(mm)※男女兼用',
      '発売元': '株式会社ひかりてらす'
    }
  },
  {
    id: '088',
    name: 'フラットポーチ',
    image: '/assets/images/goods-088_l.jpg',
    thumb: '/assets/images/goods-088_s.jpg',
    url: 'https://culcolle.online/collections/iitem-1/?ohp=grp',
    spec: {
      '価格': '各 ¥2,310円（税込）',
      '仕様': 'サイズ：W200×H150(mm)',
      '発売元': '株式会社ひかりてらす'
    }
  },
  {
    id: '087',
    name: 'ロングTシャツ',
    image: '/assets/images/goods-087_l.jpg',
    thumb: '/assets/images/goods-087_s.jpg',
    url: 'https://culcolle.online/collections/iitem-1/?ohp=grp',
    spec: {
      '価格': '各 ¥5,280円（税込）',
      '仕様': '素材：綿<br>サイズ：Lサイズ(約 身丈75cm/身幅56cm/肩幅56cm/袖丈65cm)<br>XLサイズ(約 身丈77cm/身幅61cm/肩幅57cm/袖丈65cm)',
      '発売元': '株式会社ひかりてらす'
    }
  },
  {
    id: '086',
    name: '場面写ブロマイド 第2弾全56種',
    image: '/assets/images/goods-086_l.jpg',
    thumb: '/assets/images/goods-086_s.jpg',
    url: 'https://www.sej.co.jp/products/bromide/gpbromide2009.html',
    spec: {
      '価格': '各 ¥200円（税込）',
      '仕様': 'H1076 × W1568',
      '発売元': 'セブン-イレブン'
    }
  },
  {
    id: '085',
    name: 'A3キャラファイングラフ-セカンドビジュアル-',
    image: '/assets/images/goods-085_l.jpg',
    thumb: '/assets/images/goods-085_s.jpg',
    url: 'https://tohoanimationstore.com/shop/g/gTASG01385/',
    spec: {
      '価格': '¥20,350 （税込）',
      '仕様': '●額サイズ<br>サイズ：縦約554×横約432×奥行約16mm<br>' +
        '※絵のサイズ：縦約470×横約318mm<br>' +
        '●素材<br>' +
        '額の枠：木製／裏板：木製合板／マット紙：紙製／面材：ガラス<br>' +
        'その他：押さえ金具／吊り紐・吊り金具／プレート',
      '発売元': 'TOHO animation STORE',
      '備考': '画像は制作中のサンプルのため、デザイン・仕様などは変更になる場合がございます。'
    }
  },
  {
    id: '082',
    name: '刺繍ワッペン',
    image: '/assets/images/goods-082_l.jpg',
    thumb: '/assets/images/goods-082_s.jpg',
    url: 'http://www.cocollabo.net/',
    spec: {
      '価格': '¥1,430（税込）',
      '仕様': 'サイズ：約60×60mm',
      '発売元': '株式会社キャラバン'
    }
  },
  {
    id: '081',
    name: 'フタ付マグカップ【 オリジナルパッケージドリップコーヒー付 】',
    image: '/assets/images/goods-081_l.jpg',
    thumb: '/assets/images/goods-081_s.jpg',
    url: 'http://www.cocollabo.net/',
    spec: {
      '価格': '¥2,420（税込）',
      '仕様': 'サイズ：Φ10.5×8.2cm、材質：PET、ABS樹脂、電子レンジOK',
      '発売元': '株式会社キャラバン'
    }
  },
  {
    id: '080',
    name: 'ウッドiPhone ケース',
    image: '/assets/images/goods-080_l.jpg',
    thumb: '/assets/images/goods-080_s.jpg',
    url: 'http://www.cocollabo.net/',
    spec: {
      '価格': '¥2,970（税込）',
      '仕様': '対象機種：iPhone6/6s/7/8、iPhoneX/Xs、iPhone11、iPhone11Pro',
      '発売元': '株式会社キャラバン'
    }
  },
  {
    id: '084',
    name: 'P3キャンバスアート -ティザービジュアル-',
    image: '/assets/images/goods-084_l.jpg',
    thumb: '/assets/images/goods-084_s.jpg',
    url: 'https://tohoanimationstore.com/shop/g/gTASG01355/',
    spec: {
      '価格': '¥2,500 （税込）',
      '仕様': '素材：ポリエステル、木、鉄<br>サイズ：P3サイズ（H約273mm×W約190mm×D20mm）<br>※イーゼルは付属いたしません',
      '発売元': 'TOHO animation STORE',
      '備考': '画像は制作中のサンプルのため、デザイン・仕様などは変更になる場合がございます。'
    }
  },
  {
    id: '083',
    name: 'A3キャラファイングラフ -キービジュアル-',
    image: '/assets/images/goods-083_l.jpg',
    thumb: '/assets/images/goods-083_s.jpg',
    url: 'https://tohoanimationstore.com/shop/g/gTASG01354/',
    spec: {
      '価格': '¥20,350 （税込）',
      '仕様': '●額サイズ<br>サイズ：縦約554×横約432×奥行約16mm<br>※絵のサイズ：縦約470×横約318mm<br>●素材<br>額の枠：木製／裏板：木製合板／マット紙：紙製／面材：ガラス<br>その他：押さえ金具／吊り紐・吊り金具／プレート',
      '発売元': 'TOHO animation STORE',
      '備考': '画像は制作中のサンプルのため、デザイン・仕様などは変更になる場合がございます。'
    }
  },
  {
    id: '079',
    name: 'プロテクト収納ケース',
    image: '/assets/images/goods-079_l.jpg',
    thumb: '/assets/images/goods-079_s.jpg',
    url: 'https://kyaragoods.shop-pro.jp/?mode=grp&gid=2457829',
    spec: {
      '価格': '¥2,178（税込）',
      '仕様': 'ポリエステル　H110×W160×D38ｍｍ',
      '発売元': '株式会社A3',
      '備考': '10/10(土)より発売予定'
    }
  },
  {
    id: '078',
    name: 'キャラクリアケース',
    image: '/assets/images/goods-078_l.jpg',
    thumb: '/assets/images/goods-078_s.jpg',
    url: 'https://kyaragoods.shop-pro.jp/?mode=grp&gid=2457829',
    spec: {
      '価格': '¥880（税込）',
      '仕様': 'PVC　A5サイズ(158×222mm)',
      '発売元': '株式会社A3',
      '備考': '10/10(土)より発売予定'
    }
  },
  {
    id: '077',
    name: 'レザーフセンブック(全4種)',
    image: '/assets/images/goods-077_l.jpg',
    thumb: '/assets/images/goods-077_s.jpg',
    url: 'https://kyaragoods.shop-pro.jp/?mode=grp&gid=2457829',
    spec: {
      '価格': '各¥550（税込）',
      '仕様': 'PUレザー・紙　57×11×77mm',
      '発売元': '株式会社A3',
      '備考': '10/10(土)より発売予定'
    }
  },
  {
    id: '076',
    name: 'アクリルキーホルダー(全6種)',
    image: '/assets/images/goods-076_l.jpg',
    thumb: '/assets/images/goods-076_s.jpg',
    url: 'https://kyaragoods.shop-pro.jp/?mode=grp&gid=2457829',
    spec: {
      '価格': '単品 ¥858／BOX(6個入)単品 ¥5,148（税込）',
      '仕様': 'アクリル、金属　65×65mm ',
      '発売元': '株式会社A3',
      '備考': '10/10(土)より発売予定'
    }
  },
  {
    id: '075',
    name: '缶バッジ(全6種)',
    image: '/assets/images/goods-075_l.jpg',
    thumb: '/assets/images/goods-075_s.jpg',
    url: 'https://kyaragoods.shop-pro.jp/?mode=grp&gid=2457829',
    spec: {
      '価格': '単品 ¥528／BOX(6個入)単品 ¥3,168（税込）',
      '仕様': 'ブリキ(本体)・鉄(ピン)　直径65mm',
      '発売元': '株式会社A3',
      '備考': '10/10(土)より発売予定'
    }
  },
  {
    id: '074',
    name: 'LINE着せかえ',
    image: '/assets/images/goods-074_l.jpg',
    thumb: '/assets/images/goods-074_s.jpg',
    url: 'https://line.me/S/shop/theme/detail?id=b57cac62-55fd-478c-8f65-3eab9488bfb6',
    spec: {
      '価格': '¥370（税込）または、150コイン',
      '発売開始日': '2020年9月24日',
      '仕様': 'LINEアプリ利用可能端末(iOS/Android)',
      '発売元': '株式会社インクルーズ'
    }
  },
  {
    id: '073',
    name: 'ミニチュアキャンバスキーホルダー',
    image: '/assets/images/goods-073_l.jpg',
    thumb: '/assets/images/goods-073_s.jpg',
    url: 'http://www.crysto.jp/view/category/greatpretender',
    spec: {
      '価格': '¥748（税込）',
      '仕様': 'キャンバス地、木材、　W70xH50mm ',
      '発売元': '株式会社CS.FRONT'
    }
  },
  {
    id: '072',
    name: 'レザーバッジ',
    image: '/assets/images/goods-072_l.jpg',
    thumb: '/assets/images/goods-072_s.jpg',
    url: 'http://www.crysto.jp/view/category/greatpretender',
    spec: {
      '価格': '¥660（税込）',
      '仕様': 'PUレザー　約57mm',
      '発売元': '株式会社CS.FRONT'
    }
  },
  {
    id: '071',
    name: 'マグネット（全10種）',
    image: '/assets/images/goods-071_l.jpg',
    thumb: '/assets/images/goods-071_s.jpg',
    url: 'https://ja.otakumode.com/collections/greatpretender/',
    spec: {
      '価格': '各 ¥440（税込）',
      '仕様': '80x35mm、ブリキ、PP、磁石',
      '発売元': 'Tokyo Otaku Mode Inc.日本支店'
    }
  },
  {
    id: '070',
    name: 'エダマメ印のドリップコーヒー',
    image: '/assets/images/goods-070_l.jpg',
    thumb: '/assets/images/goods-070_s.jpg',
    url: 'https://ja.otakumode.com/collections/greatpretender/',
    spec: {
      '価格': '¥385（税込）',
      '仕様': 'コーヒー豆、紙',
      '発売元': 'Tokyo Otaku Mode Inc.日本支店'
    }
  },
  {
    id: '069',
    name: 'ノート＆ペンセット',
    image: '/assets/images/goods-069_l.jpg',
    thumb: '/assets/images/goods-069_s.jpg',
    url: 'https://ja.otakumode.com/collections/greatpretender/',
    spec: {
      '価格': '¥1,100（税込）',
      '仕様': 'ノート90x140x12mm、ペン140x13x10mm、紙・ABS樹脂・鉄',
      '発売元': 'Tokyo Otaku Mode Inc.日本支店'
    }
  },
  {
    id: '068',
    name: 'シャンパングラス',
    image: '/assets/images/goods-068_l.jpg',
    thumb: '/assets/images/goods-068_s.jpg',
    url: 'https://ja.otakumode.com/collections/greatpretender/',
    spec: {
      '価格': '¥1,650（税込）',
      '仕様': '口径 55mm、高さ 193mm、165cc、ガラス',
      '発売元': 'Tokyo Otaku Mode Inc.日本支店'
    }
  },
  {
    id: '067',
    name: 'キャップ',
    image: '/assets/images/goods-067_l.jpg',
    thumb: '/assets/images/goods-067_s.jpg',
    url: 'https://ja.otakumode.com/collections/greatpretender/',
    spec: {
      '価格': '¥3,850（税込）',
      '仕様': '頭周り 約570〜600mm、綿（表地）',
      '発売元': 'Tokyo Otaku Mode Inc.日本支店'
    }
  },
  {
    id: '066',
    name: 'トートバッグ（ロゴ）',
    image: '/assets/images/goods-066_l.jpg',
    thumb: '/assets/images/goods-066_s.jpg',
    url: 'https://ja.otakumode.com/collections/greatpretender/',
    spec: {
      '価格': '¥2,750（税込）',
      '仕様': '本体 480×400×150mm、持ち手30x600mm、綿',
      '発売元': 'Tokyo Otaku Mode Inc.日本支店'
    }
  },
  {
    id: '065',
    name: 'Tシャツ（ロゴ）',
    image: '/assets/images/goods-065_l.jpg',
    thumb: '/assets/images/goods-065_s.jpg',
    url: 'https://ja.otakumode.com/collections/greatpretender/',
    spec: {
      '価格': '¥3,850（税込）',
      '仕様': 'S〜XL、綿',
      '発売元': 'Tokyo Otaku Mode Inc.日本支店'
    }
  },
  {
    id: '064',
    name: 'グラス（イメージビジュアル）全4種',
    image: '/assets/images/goods-064_l.jpg',
    thumb: '/assets/images/goods-064_s.jpg',
    url: 'https://ja.otakumode.com/collections/greatpretender/',
    spec: {
      '価格': '各 ¥1,100（税込）',
      '仕様': '口径 56mm、高さ 150mm、280cc、ガラス',
      '発売元': 'Tokyo Otaku Mode Inc.日本支店'
    }
  },
  {
    id: '063',
    name: 'クリアファイル（イメージビジュアル）全4種',
    image: '/assets/images/goods-063_l.jpg',
    thumb: '/assets/images/goods-063_s.jpg',
    url: 'https://ja.otakumode.com/collections/greatpretender/',
    spec: {
      '価格': '各 ¥440（税込）',
      '仕様': 'A4対応サイズ、PP',
      '発売元': 'Tokyo Otaku Mode Inc.日本支店'
    }
  },
  {
    id: '062',
    name: 'トートバッグ（描き下ろし）',
    image: '/assets/images/goods-062_l.jpg',
    thumb: '/assets/images/goods-062_s.jpg',
    url: 'https://ja.otakumode.com/collections/greatpretender/',
    spec: {
      '価格': '¥2,750（税込）',
      '仕様': '本体 480×400×150mm、持ち手30x600mm、綿',
      '発売元': 'Tokyo Otaku Mode Inc.日本支店'
    }
  },
  {
    id: '061',
    name: 'Tシャツ（描き下ろし）',
    image: '/assets/images/goods-061_l.jpg',
    thumb: '/assets/images/goods-061_s.jpg',
    url: 'https://ja.otakumode.com/collections/greatpretender/',
    spec: {
      '価格': '¥3,850（税込）',
      '仕様': 'S〜XL、綿',
      '発売元': 'Tokyo Otaku Mode Inc.日本支店'
    }
  },
  {
    id: '060',
    name: 'フェイスタオル（描き下ろし）',
    image: '/assets/images/goods-060_l.jpg',
    thumb: '/assets/images/goods-060_s.jpg',
    url: 'https://ja.otakumode.com/collections/greatpretender/',
    spec: {
      '価格': '¥2,750（税込）',
      '仕様': '340x800mm、綿',
      '発売元': 'Tokyo Otaku Mode Inc.日本支店'
    }
  },
  {
    id: '059',
    name: 'アートパネル（描き下ろし）',
    image: '/assets/images/goods-059_l.jpg',
    thumb: '/assets/images/goods-059_s.jpg',
    url: 'https://ja.otakumode.com/collections/greatpretender/',
    spec: {
      '価格': '¥3,850（税込）',
      '発売元': 'Tokyo Otaku Mode Inc.日本支店'
    }
  },
  {
    id: '058',
    name: 'アクリルプレート（描き下ろし）',
    image: '/assets/images/goods-058_l.jpg',
    thumb: '/assets/images/goods-058_s.jpg',
    url: 'https://ja.otakumode.com/collections/greatpretender/',
    spec: {
      '価格': '¥2,200（税込）',
      '仕様': '150x95mm、アクリル、アルミ',
      '発売元': 'Tokyo Otaku Mode Inc.日本支店'
    }
  },
  {
    id: '057',
    name: 'アクリルスタンド（描き下ろし）全2種',
    image: '/assets/images/goods-057_l.jpg',
    thumb: '/assets/images/goods-057_s.jpg',
    url: 'https://ja.otakumode.com/collections/greatpretender/',
    spec: {
      '価格': '各 ¥1,650（税込）',
      '仕様': '本体180x90mm 台座60x60mm、アクリル',
      '発売元': 'Tokyo Otaku Mode Inc.日本支店'
    }
  },
  {
    id: '056',
    name: 'クリアファイル（描き下ろし）全2種',
    image: '/assets/images/goods-056_l.jpg',
    thumb: '/assets/images/goods-056_s.jpg',
    url: 'https://ja.otakumode.com/collections/greatpretender/',
    spec: {
      '価格': '各 ¥440（税込）',
      '仕様': 'A4対応サイズ、PP',
      '発売元': 'Tokyo Otaku Mode Inc.日本支店'
    }
  },
  {
    id: '055',
    name: '場面写ブロマイド 第1弾（全32種）',
    image: '/assets/images/goods-055_l.jpg',
    thumb: '/assets/images/goods-055_s.jpg',
    url: 'https://www.sej.co.jp/products/bromide/gpbromide2009.html',
    spec: {
      '価格': '各 ¥200（税込）',
      '仕様': 'H1076 × W1568',
      '発売元': 'セブン-イレブン'
    }
  },
  {
    id: '044',
    name: 'プレミアムチケットケース',
    image: '/assets/images/goods-044_l.jpg',
    thumb: '/assets/images/goods-044_s.jpg',
    url: 'https://karutassu.com/',
    spec: {
      '価格': '¥3,498（税込）',
      '仕様': '合皮 約205mm×100mm',
      '発売元': 'プレイフルマインドカンパニー'
    }
  },
  {
    id: '045',
    name: '丸型コインケース',
    image: '/assets/images/goods-045_l.jpg',
    thumb: '/assets/images/goods-045_s.jpg',
    url: 'https://karutassu.com/',
    spec: {
      '価格': '¥2,178（税込）',
      '仕様': '合皮 約φ95mm',
      '発売元': 'プレイフルマインドカンパニー'
    }
  },
  {
    id: '046',
    name: 'レザーバッジ（全4種）',
    image: '/assets/images/goods-046_l.jpg',
    thumb: '/assets/images/goods-046_s.jpg',
    url: 'https://karutassu.com/',
    spec: {
      '価格': '¥748（税込）',
      '仕様': '合皮 約55mm×55mm',
      '発売元': 'プレイフルマインドカンパニー'
    }
  },
  {
    id: '047',
    name: 'コードクリップ（全4種）',
    image: '/assets/images/goods-047_l.jpg',
    thumb: '/assets/images/goods-047_s.jpg',
    url: 'https://karutassu.com/',
    spec: {
      '価格': '¥1,408（税込）',
      '仕様': '合皮 約58mm×53mm ',
      '発売元': 'プレイフルマインドカンパニー'
    }
  },
  {
    id: '048',
    name: 'パスケース（全2種）',
    image: '/assets/images/goods-048_l.jpg',
    thumb: '/assets/images/goods-048_s.jpg',
    url: 'https://karutassu.com/',
    spec: {
      '価格': '¥1,078（税込）',
      '仕様': '合皮 約105mm×70mm（チェーン約40mm）',
      '発売元': 'プレイフルマインドカンパニー'
    }
  },
  {
    id: '049',
    name: 'キーケース',
    image: '/assets/images/goods-049_l.jpg',
    thumb: '/assets/images/goods-049_s.jpg',
    url: 'https://karutassu.com/',
    spec: {
      '価格': '¥3,058（税込）',
      '仕様': '合皮 約75mm×105mm',
      '発売元': 'プレイフルマインドカンパニー'
    }
  },
  {
    id: '050',
    name: 'ボールペン',
    image: '/assets/images/goods-050_l.jpg',
    thumb: '/assets/images/goods-050_s.jpg',
    url: 'https://karutassu.com/',
    spec: {
      '価格': '¥748（税込）',
      '仕様': 'ABS・AS・スチール・紙 約145mm×15mm',
      '発売元': 'プレイフルマインドカンパニー'
    }
  },
  {
    id: '051',
    name: 'アンブレラチャーム（全4種）',
    image: '/assets/images/goods-051_l.jpg',
    thumb: '/assets/images/goods-051_s.jpg',
    url: 'https://karutassu.com/',
    spec: {
      '価格': '¥1,408（税込）',
      '仕様': 'アクリル 約70mm×70mm 以内',
      '発売元': 'プレイフルマインドカンパニー'
    }
  },
  {
    id: '052',
    name: 'ハンドタオル',
    image: '/assets/images/goods-052_l.jpg',
    thumb: '/assets/images/goods-052_s.jpg',
    url: 'https://karutassu.com/',
    spec: {
      '価格': '¥858（税込）',
      '仕様': 'ポリエステル・綿 約250×250mm',
      '発売元': 'プレイフルマインドカンパニー'
    }
  },
  {
    id: '053',
    name: '手帳型スマホケース（マルチ）',
    image: '/assets/images/goods-053_l.jpg',
    thumb: '/assets/images/goods-053_s.jpg',
    url: 'https://karutassu.com/',
    spec: {
      '価格': '¥3,608（税込）',
      '仕様': '合皮　マルチ(M,L)',
      '発売元': 'プレイフルマインドカンパニー'
    }
  },
  {
    id: '054',
    name: '手帳型スマホケース（iPhone）',
    image: '/assets/images/goods-054_l.jpg',
    thumb: '/assets/images/goods-054_s.jpg',
    url: 'https://karutassu.com/',
    spec: {
      '価格': '¥3,608（税込）',
      '仕様': '合皮　iphone(5,5s,SE/6,7,8/11,11pro/6p,7p,8p/X,XS/XR/XS Max/11proMax)',
      '発売元': 'プレイフルマインドカンパニー'
    }
  },
  {
    id: '040',
    name: 'アクリルスタンド（全２種）',
    image: '/assets/images/goods-040_l.jpg',
    thumb: '/assets/images/goods-040_s.jpg',
    url: 'http://www.crux-onlinestore.com/shopbrand/ct66',
    spec: {
      '価格': '¥1,320（税込）',
      '仕様': 'アクリル 約W68×H155mm',
      '発売元': '株式会社クラックス'
    }
  },
  {
    id: '041',
    name: 'アクリルコースター（全２種）',
    image: '/assets/images/goods-041_l.jpg',
    thumb: '/assets/images/goods-041_s.jpg',
    url: 'http://www.crux-onlinestore.com/shopbrand/ct66',
    spec: {
      '価格': '¥770（税込）',
      '仕様': 'アクリル 約W86×H86mm',
      '発売元': '株式会社クラックス'
    }
  },
  {
    id: '042',
    name: 'シングルクリアファイル（全２種）',
    image: '/assets/images/goods-042_l.jpg',
    thumb: '/assets/images/goods-042_s.jpg',
    url: 'http://www.crux-onlinestore.com/shopbrand/ct66',
    spec: {
      '価格': '¥440（税込）',
      '仕様': 'PP　A4対応　約H310×W220ｍｍ',
      '発売元': '株式会社クラックス'
    }
  },
  {
    id: '043',
    name: 'ボールペン（全２種）',
    image: '/assets/images/goods-043_l.jpg',
    thumb: '/assets/images/goods-043_s.jpg',
    url: 'http://www.crux-onlinestore.com/shopbrand/ct66',
    spec: {
      '価格': '¥660（税込）',
      '仕様': 'ABS　約H135×φ13ｍｍ',
      '発売元': '株式会社クラックス'
    }
  },
  {
    id: '038',
    name: 'GREAT PRETENDER コレクション',
    image: '/assets/images/goods-038_l.jpg',
    thumb: '/assets/images/goods-038_s.jpg',
    url: 'https://collection.rakuten.net/collection/greatpretender/',
    spec: {
      '価格': '¥660（税込）',
      '販売方法': '楽天コレクション（オンラインくじ）',
      '発売元': '楽天株式会社'
    }
  },
  {
    id: '039',
    name: 'ファミマプリントブロマイド',
    image: '/assets/images/goods-039_l.jpg',
    thumb: '/assets/images/goods-039_s.jpg',
    url: 'https://fp.famima.com/anime/greatpretender',
    spec: {
      '価格': 'L版：300円、2L版：500円（税込）',
      '仕様': 'L版、2L版',
      '発売元': '楽天株式会社'
    }
  },
  {
    id: '037',
    name: 'アクリルスタンド',
    image: '/assets/images/goods-037_l.jpg',
    thumb: '/assets/images/goods-037_s.jpg',
    url: 'http://www.crysto.jp/view/category/greatpretender',
    spec: {
      '価格': '各 ¥990（税込）',
      '仕様': 'アクリル　W65xH65mm',
      '発売元': '株式会社CS.FRONT'
    }
  },
  {
    id: '036',
    name: 'メタリック缶バッジ',
    image: '/assets/images/goods-036_l.jpg',
    thumb: '/assets/images/goods-036_s.jpg',
    url: 'http://www.crysto.jp/view/category/greatpretender',
    spec: {
      '価格': '各 ¥660（税込）',
      '仕様': 'ブリキ、PP　約56㎜',
      '発売元': '株式会社CS.FRONT'
    }
  },
  {
    id: '035',
    name: 'アクリルキーホルダー',
    image: '/assets/images/goods-035_l.jpg',
    thumb: '/assets/images/goods-035_s.jpg',
    url: 'http://www.crysto.jp/view/category/greatpretender',
    spec: {
      '価格': '各 ¥880（税込）',
      '仕様': 'アクリル　W65xH65mm',
      '発売元': '株式会社CS.FRONT'
    }
  },
  {
    id: '034',
    name: 'グラフィックアートバックパック',
    image: '/assets/images/goods-034_l.jpg',
    thumb: '/assets/images/goods-034_s.jpg',
    url: 'https://aniga-ter.com/',
    spec: {
      '価格': '¥8,250（税込）',
      '仕様': 'ポリエステル　約H42×W34×D13cm',
      '発売元': 'バナナスピリッツ株式会社'
    }
  },
  {
    id: '033',
    name: 'グラフィックアートキャンバス 「シンシア」',
    image: '/assets/images/goods-033_l.jpg',
    thumb: '/assets/images/goods-033_s.jpg',
    url: 'https://aniga-ter.com/',
    spec: {
      '価格': '¥4,840（税込）',
      '仕様': '木、綿、混紡材　約H27.3 x W22cm',
      '発売元': 'バナナスピリッツ株式会社'
    }
  },
  {
    id: '032',
    name: 'グラフィックアートキャンバス 「アビー」',
    image: '/assets/images/goods-032_l.jpg',
    thumb: '/assets/images/goods-032_s.jpg',
    url: 'https://aniga-ter.com/',
    spec: {
      '価格': '¥4,840（税込）',
      '仕様': '木、綿、混紡材　約H27.3 x W22cm',
      '発売元': 'バナナスピリッツ株式会社'
    }
  },
  {
    id: '031',
    name: 'グラフィックアートキャンバス 「ローラン」',
    image: '/assets/images/goods-031_l.jpg',
    thumb: '/assets/images/goods-031_s.jpg',
    url: 'https://aniga-ter.com/',
    spec: {
      '価格': '¥4,840（税込）',
      '仕様': '木、綿、混紡材　約H27.3 x W22cm',
      '発売元': 'バナナスピリッツ株式会社'
    }
  },
  {
    id: '030',
    name: 'グラフィックアートキャンバス 「枝村真人」',
    image: '/assets/images/goods-030_l.jpg',
    thumb: '/assets/images/goods-030_s.jpg',
    url: 'https://aniga-ter.com/',
    spec: {
      '価格': '¥4,840（税込）',
      '仕様': '木、綿、混紡材　約H27.3 x W22cm',
      '発売元': 'バナナスピリッツ株式会社'
    }
  },
  {
    id: '029',
    name: 'グラフィックアートiPhone 11対応ケース',
    image: '/assets/images/goods-029_l.jpg',
    thumb: '/assets/images/goods-029_s.jpg',
    url: 'https://aniga-ter.com/',
    spec: {
      '価格': '¥3,850（税込）',
      '仕様': 'ポリカ―ボネート　iPhone 11対応',
      '発売元': 'バナナスピリッツ株式会社'
    }
  },
  {
    id: '028',
    name: 'グラフィックアートiPhone X.XS対応ケース',
    image: '/assets/images/goods-028_l.jpg',
    thumb: '/assets/images/goods-028_s.jpg',
    url: 'https://aniga-ter.com/',
    spec: {
      '価格': '¥3,850（税込）',
      '仕様': 'ポリカ―ボネート　iPhone X.XS対応',
      '発売元': 'バナナスピリッツ株式会社'
    }
  },
  {
    id: '027',
    name: 'グラフィックアートiPhone 6.7.8対応ケース',
    image: '/assets/images/goods-027_l.jpg',
    thumb: '/assets/images/goods-027_s.jpg',
    url: 'https://aniga-ter.com/',
    spec: {
      '価格': '¥3,850（税込）',
      '仕様': 'ポリカ―ボネート　iPhone 6.6S.7.8対応',
      '発売元': 'バナナスピリッツ株式会社'
    }
  },
  {
    id: '026',
    name: 'グラフィックアートTシャツ 「シンシア」',
    image: '/assets/images/goods-026_l.jpg',
    thumb: '/assets/images/goods-026_s.jpg',
    url: 'https://aniga-ter.com/',
    spec: {
      '価格': '¥3,850（税込）',
      '仕様':
        '素材：綿<br>' +
        'サイズ：Sサイズ（約 身丈65㎝/身幅48㎝/肩幅41㎝/袖丈21㎝）<br>' +
        'サイズ：Mサイズ（約 身丈68㎝/身幅50㎝/肩幅43㎝/袖丈21㎝）<br>' +
        'サイズ：Lサイズ（約 身丈71㎝/身幅53㎝/肩幅44㎝/袖丈22㎝）<br>',
      '発売元': 'バナナスピリッツ株式会社'
    }
  },
  {
    id: '025',
    name: 'グラフィックアートTシャツ 「アビー」',
    image: '/assets/images/goods-025_l.jpg',
    thumb: '/assets/images/goods-025_s.jpg',
    url: 'https://aniga-ter.com/',
    spec: {
      '価格': '¥3,850（税込）',
      '仕様':
        '素材：綿<br>' +
        'サイズ：Sサイズ（約 身丈65㎝/身幅48㎝/肩幅41㎝/袖丈21㎝）<br>' +
        'サイズ：Mサイズ（約 身丈68㎝/身幅50㎝/肩幅43㎝/袖丈21㎝）<br>' +
        'サイズ：Lサイズ（約 身丈71㎝/身幅53㎝/肩幅44㎝/袖丈22㎝）<br>',
      '発売元': 'バナナスピリッツ株式会社'
    }
  },
  {
    id: '024',
    name: 'グラフィックアートTシャツ 「ローラン」',
    image: '/assets/images/goods-024_l.jpg',
    thumb: '/assets/images/goods-024_s.jpg',
    url: 'https://aniga-ter.com/',
    spec: {
      '価格': '¥3,850（税込）',
      '仕様':
        '素材：綿<br>' +
        'サイズ：Sサイズ（約 身丈65㎝/身幅48㎝/肩幅41㎝/袖丈21㎝）<br>' +
        'サイズ：Mサイズ（約 身丈68㎝/身幅50㎝/肩幅43㎝/袖丈21㎝）<br>' +
        'サイズ：Lサイズ（約 身丈71㎝/身幅53㎝/肩幅44㎝/袖丈22㎝）<br>',
      '発売元': 'バナナスピリッツ株式会社'
    }
  },
  {
    id: '023',
    name: 'グラフィックアートTシャツ 「枝村真人」',
    image: '/assets/images/goods-023_l.jpg',
    thumb: '/assets/images/goods-023_s.jpg',
    url: 'https://aniga-ter.com/',
    spec: {
      '価格': '¥3,850（税込）',
      '仕様':
        '素材：綿<br>' +
        'サイズ：Sサイズ（約 身丈65㎝/身幅48㎝/肩幅41㎝/袖丈21㎝）<br>' +
        'サイズ：Mサイズ（約 身丈68㎝/身幅50㎝/肩幅43㎝/袖丈21㎝）<br>' +
        'サイズ：Lサイズ（約 身丈71㎝/身幅53㎝/肩幅44㎝/袖丈22㎝）<br>',
      '発売元': 'バナナスピリッツ株式会社'
    }
  },
  {
    id: '021',
    name: 'スクエア缶バッジ シンシア',
    image: '/assets/images/goods-021_l.jpg',
    thumb: '/assets/images/goods-021_s.jpg',
    url: 'http://www.witstudio.co.jp/goods/2020/08/305.html',
    spec: {
      '価格': '¥550（税込）',
      '仕様': 'H78×W54㎜',
      '発売元': 'WIT STUDIO'
    }
  },
  {
    id: '020',
    name: 'スクエア缶バッジ アビー',
    image: '/assets/images/goods-020_l.jpg',
    thumb: '/assets/images/goods-020_s.jpg',
    url: 'http://www.witstudio.co.jp/goods/2020/08/304.html',
    spec: {
      '価格': '¥550（税込）',
      '仕様': 'H78×W54㎜',
      '発売元': 'WIT STUDIO'
    }
  },
  {
    id: '017',
    name: '原画クリアファイル（全４種）',
    image: '/assets/images/goods-017-2_l.jpg',
    thumb: '/assets/images/goods-017-2_s.jpg',
    url: 'http://www.witstudio.co.jp/goods/2020/07/302.html',
    spec: {
      '価格': '各 ¥440（税込）',
      '仕様':
        '全4種<br>' +
        'PP　A4対応',
      '発売元': 'WIT STUDIO'
    }
  },
  {
    id: '022',
    name: 'LINEスタンプ',
    image: '/assets/images/goods-022_l.jpg',
    thumb: '/assets/images/goods-022_s.jpg',
    url: 'https://store.line.me/stickershop/product/12101782',
    spec: {
      '価格': '¥250（税込）',
      '仕様': 'LINEスタンプ（全40種）',
      '発売元': 'WIT STUDIO'
    }
  },
  {
    id: '019',
    name: 'トレーディングアクリルキーホルダー',
    image: '/assets/images/goods-019_l.jpg',
    thumb: '/assets/images/goods-019_s.jpg',
    url: 'http://www.witstudio.co.jp/goods/2020/07/300.html',
    spec: {
      '価格': '各 ¥660（税込）',
      '仕様': '約W60mm×H65mm',
      '発売元': 'WIT STUDIO'
    }
  },
  {
    id: '018',
    name: '缶バッジ 6種セット',
    image: '/assets/images/goods-018_l.jpg',
    thumb: '/assets/images/goods-018_s.jpg',
    url: 'http://www.witstudio.co.jp/goods/2020/07/301.html',
    spec: {
      '価格': '¥2,200（税込）',
      '仕様': '缶バッジ：直径約57mm／台紙：A5',
      '発売元': 'WIT STUDIO'
    }
  },
  {
    id: '016',
    name: 'スマホバンド',
    image: '/assets/images/goods-016_l.jpg',
    thumb: '/assets/images/goods-016_s.jpg',
    url: 'http://www.witstudio.co.jp/goods/2020/07/299.html',
    spec: {
      '価格': '各 ¥1,650（税込）',
      '仕様':
        '全２種<br>' +
        'TPU、ABS　W25×H80㎜',
      '発売元': 'WIT STUDIO'
    }
  },
  {
    id: '015',
    name: 'マグカップ',
    image: '/assets/images/goods-015_l.jpg',
    thumb: '/assets/images/goods-015_s.jpg',
    url: 'http://www.witstudio.co.jp/goods/2020/07/298.html',
    spec: {
      '価格': '¥1,650（税込）',
      '仕様': '陶器　直径約8.2cm×高さ約9.6cm',
      '発売元': 'WIT STUDIO'
    }
  },
  {
    id: '014',
    name: 'ポーチ',
    image: '/assets/images/goods-014_l.jpg',
    thumb: '/assets/images/goods-014_s.jpg',
    url: 'http://www.witstudio.co.jp/goods/2020/07/297.html',
    spec: {
      '価格': '¥1,650（税込）',
      '仕様': '綿　約W22.3cm×H17.1cm',
      '発売元': 'WIT STUDIO'
    }
  },
  {
    id: '013',
    name: 'トートバッグ＆キーホルダー',
    image: '/assets/images/goods-013_l.jpg',
    thumb: '/assets/images/goods-013_s.jpg',
    url: 'http://www.witstudio.co.jp/goods/2020/07/296.html',
    spec: {
      '価格': '¥3,300（税込）',
      '仕様':
        'トートバッグ：綿　W36cm×H37cm×D11cm<br>' +
        'アクリルキーホルダー：樹脂・鉄　約2.7cm×5.4cm',
      '発売元': 'WIT STUDIO'
    }
  },
  {
    id: '012',
    name: '手帳型スマートフォンケース',
    image: '/assets/images/goods-012_l.jpg',
    thumb: '/assets/images/goods-012_s.jpg',
    url: 'http://ig-store.jp/',
    spec: {
      '価格': '¥3,850（税込）',
      '仕様':
        '粘着テープ式、カメラ・スライド機能付き<br>' +
        '素材：ポリウレタン、ABS樹脂、ポリエステル、ステンレススチール、PET<br>' +
        '本体サイズ：約150×80mm<br>' +
        '※装着可能なスマートフォンサイズ：長辺の長さ150mmまで。短辺の長さ75mmまで。',
      '発売元': '株式会社ムービック'
    }
  },
  {
    id: '011',
    name: 'Tシャツ',
    image: '/assets/images/goods-011_l.jpg',
    thumb: '/assets/images/goods-011_s.jpg',
    url: 'http://ig-store.jp/',
    spec: {
      '価格': '¥3,850（税込）',
      '仕様':
        '素材：綿100％　　サイズ：Mサイズ（身丈69cm/身幅52cm/肩幅46cm/袖丈20cm）<br>' +
        'サイズ：Lサイズ（身丈73cm/身幅55cm/肩幅50cm/袖丈22cm）',
      '発売元': '株式会社ムービック'
    }
  },
  {
    id: '010',
    name: 'ビッグシルエットTシャツ',
    image: '/assets/images/goods-010_l.jpg',
    thumb: '/assets/images/goods-010_s.jpg',
    url: 'http://ig-store.jp/',
    spec: {
      '価格': '¥4,950（税込）',
      '仕様': '素材：綿100％　　サイズ：フリーサイズ（身丈73cm/身幅61cm/肩幅58cm/袖丈25cm）',
      '発売元': '株式会社ムービック'
    }
  },
  {
    id: '009',
    name: 'トートバッグ',
    image: '/assets/images/goods-009_l.jpg',
    thumb: '/assets/images/goods-009_s.jpg',
    url: 'http://ig-store.jp/',
    spec: {
      '価格': '¥2,750（税込）',
      '仕様': '素材：綿100％　　サイズ：本体約W360×H370ｍｍ',
      '発売元': '株式会社ムービック'
    }
  },
  {
    id: '008',
    name: 'Tシャツ',
    image: '/assets/images/goods-008_l.jpg',
    thumb: '/assets/images/goods-008_s.jpg',
    url: 'https://core-choco.shop-pro.jp/?pid=152068143',
    spec: {
      '価格': '¥4,400（税込）',
      '仕様': 'ハリウッド・ブラック（全１種）　綿 100%  サイズ展開:160/S/M/L/XL/XXL',
      '発売元': '有限会社ハードコアチョコレート'
    }
  },
  {
    id: '007',
    name: 'メタリックタンブラー',
    image: '/assets/images/goods-007_l.jpg',
    thumb: '/assets/images/goods-007_s.jpg',
    url: 'http://www.crysto.jp/view/item/000000000046',
    spec: {
      '価格': '¥1,650（税込）',
      '仕様': '約H195×W85(mm)',
      '発売元': '株式会社CS.FRONT'
    }
  },
  {
    id: '006',
    name: '手帳型スマホケース',
    image: '/assets/images/goods-006_l.jpg',
    thumb: '/assets/images/goods-006_s.jpg',
    url: 'http://www.crysto.jp/view/item/000000000044',
    spec: {
      '価格': '¥3,278（税込）',
      '仕様': '約H156×W185(mm)',
      '発売元': '株式会社CS.FRONT'
    }
  },
  {
    id: '005',
    name: 'レザーパスケース',
    image: '/assets/images/goods-005_l.jpg',
    thumb: '/assets/images/goods-005_s.jpg',
    url: 'http://www.crysto.jp/view/item/000000000043',
    spec: {
      '価格': '¥1,430（税込）',
      '仕様': '各 約H100×W70(mm)',
      '発売元': '株式会社CS.FRONT'
    }
  },
  {
    id: '001',
    name: 'クリアファイル',
    image: '/assets/images/goods-001_l.jpg',
    thumb: '/assets/images/goods-001_s.jpg',
    url: 'http://www.witstudio.co.jp/goods/2020/05/283.html',
    spec: {
      '価格': '¥440（税込）',
      '仕様': 'A4対応',
      '発売元': 'WIT STUDIO'
    }
  },
  {
    id: '002',
    name: 'ステッカーセット',
    image: '/assets/images/goods-002_l.jpg',
    thumb: '/assets/images/goods-002_s.jpg',
    url: 'http://www.witstudio.co.jp/goods/2020/05/284.html',
    spec: {
      '価格': '¥550（税込）',
      '仕様': '各 H80×W60(mm)',
      '発売元': 'WIT STUDIO'
    }
  },
  {
    id: '003',
    name: 'スクエア缶バッジ（エダマメ）',
    image: '/assets/images/goods-003_l.jpg',
    thumb: '/assets/images/goods-003_s.jpg',
    url: 'http://www.witstudio.co.jp/goods/2020/05/285.html',
    spec: {
      '価格': '¥550（税込）',
      '仕様': 'H78×W54(mm)',
      '発売元': 'WIT STUDIO'
    }
  },
  {
    id: '004',
    name: 'スクエア缶バッジ（ローラン）',
    image: '/assets/images/goods-004_l.jpg',
    thumb: '/assets/images/goods-004_s.jpg',
    url: 'http://www.witstudio.co.jp/goods/2020/05/286.html',
    spec: {
      '価格': '¥550（税込）',
      '仕様': 'H78×W54(mm)',
      '発売元': 'WIT STUDIO'
    }
  }
]



// WEBPACK FOOTER //
// ./src/data/goods.js